import { useState } from "react";
import { FileUpload } from "primereact/fileupload";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { Card } from "primereact/card";

const PagosMasivos = () => {
  const axiosPrivate = useAxiosPrivate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [showAlumnoModal, setShowAlumnoModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [alumnos, setAlumnos] = useState([]);
  const [search, setSearch] = useState("");

  const handleUpload = async ({ files }) => {
    const file = files[0];
    const formData = new FormData();
    formData.append("file", file);
    try {
      setLoading(true);
      const res = await axiosPrivate.post("CEUM/pagos/preview", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setData(res.data);
    } catch (e) {
      console.error(e);
      alert("Error al procesar archivo");
    } finally {
      setLoading(false);
    }
  };
  const aplicar = async () => {
    try {
      await axiosPrivate.post("CEUM/pagos/masivo", {
        items: data.filter((d) => d.valido),
      });
      alert("Pagos aplicados");
      setData([]);
    } catch (e) {
      console.error(e);
    }
  };
  const statusBody = (row) => (
    <span style={{ color: row.valido ? "green" : "red" }}>
      {row.valido ? "✔" : "✖"}
    </span>
  );
  const abrirBusqueda = (row) => {
    setSelectedRow(row);
    setShowAlumnoModal(true);
  };
  const seleccionarAlumno = (alumno) => {
    const nuevos = data.map((d) => {
      if (d === selectedRow) {
        return {
          ...d,
          matricula: alumno.Matricula,
          nombre: alumno.nombre,
          grado: alumno.grado,
          grupo: alumno.grupo,
          valido: true,
          mensaje: "Asignado manualmente",
        };
      }

      return d;
    });

    setData(nuevos);

    setShowAlumnoModal(false);
  };
  const buscarAlumnos = async () => {
    try {
      const res = await axiosPrivate.get(`CEUM/alumnos/buscar?q=${search}`);

      setAlumnos(res.data);
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <>
      <Card title="Pagos Masivos (Banco)">
        <FileUpload
          name="file"
          accept=".xlsx,.csv"
          customUpload
          uploadHandler={handleUpload}
          chooseLabel="Cargar archivo banco"
        />
        <DataTable value={data} loading={loading} className="mt-3">
          <Column field="matricula" header="Matrícula" />
          <Column field="nombre" header="Nombre" />
          <Column field="grado" header="Grado" />
          <Column field="grupo" header="Grupo" />
          <Column field="monto" header="Monto" />
          <Column field="fecha" header="Fecha" />
          <Column header="Estado" body={statusBody} />
          <Column field="mensaje" header="Detalle" />
          <Column field="concepto" header="Concepto" />
          <Column
            header="Acción"
            body={(row) =>
              !row.valido ? (
                <Button
                  icon="pi pi-search"
                  severity="warning"
                  rounded
                  onClick={() => abrirBusqueda(row)}
                />
              ) : null
            }
          />
        </DataTable>
        {data.length > 0 && (
          <div className="flex justify-content-end mt-3">
            <Button
              label="Aplicar pagos"
              icon="pi pi-check"
              onClick={aplicar}
            />
          </div>
        )}

        <Dialog
          header="Buscar alumno"
          visible={showAlumnoModal}
          style={{ width: "60vw" }}
          onHide={() => {
            setShowAlumnoModal(false);
          }}
        >
          <div className="flex gap-2 mb-3">
            <InputText
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Nombre o matrícula"
              className="w-full"
            />

            <Button
              label="Buscar"
              icon="pi pi-search"
              onClick={buscarAlumnos}
            />
          </div>

          <DataTable value={alumnos} paginator rows={5}>
            <Column field="Matricula" header="Matrícula" />

            <Column field="nombre" header="Nombre" />

            <Column field="grado" header="Grado" />

            <Column field="grupo" header="Grupo" />

            <Column
              body={(row) => (
                <Button
                  label="Seleccionar"
                  onClick={() => {
                    seleccionarAlumno(row);
                    setAlumnos([]);
                    setSearch("");
                  }}
                />
              )}
            />
          </DataTable>
        </Dialog>
      </Card>
    </>
  );
};

export default PagosMasivos;
